import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

/** Navy block-radius square that appears after 300px of scroll. */
const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`fixed bottom-24 right-4 z-30 transition-all duration-300 ease-out md:bottom-8 md:right-8 ${
        isVisible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <button
        type="button"
        onClick={scrollToTop}
        className="flex h-11 w-11 items-center justify-center rounded-block border border-border bg-navy text-white shadow-surface transition-colors duration-200 hover:bg-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        aria-label="Back to top"
      >
        <ArrowUp className="h-5 w-5" strokeWidth={2} aria-hidden="true" />
      </button>
    </div>
  );
};

export default BackToTop;
